var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notice"},[_c('div',{staticClass:"notice-common notice-right",on:{"click":_vm.tourl}},[_c('div',{staticClass:"notice-right-top"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }